import React, { Component } from 'react';
import Hero from "../modules/Hero/Hero";
import SecondHeading from "../modules/SecondHeading";
import ThreeColumnIcons from "../modules/ThreeColumnIcons/ThreeColumnIcons";
import globals from '../globals';
import PartnersForm from "../forms/PartnersForm/PartnersForm";
import HelmetDefault from "../layout/HelmetDefault";
import Button from "../elements/Button";

class AwsPartners extends Component {

    constructor() {
        super();

        this.state = {
            title: '',
            subTitle: '',
            leadCopy: [],
            secondHeading: {},
            threeColumn: {},
            seoTitle: '',
            seoDescription: '',
            dataReceived: false
        };
    }

    componentDidMount() {
        this.getData();
    }

    getData() {
        fetch('/api/aws-partners')
            .then(result => result.json())
            .then((result) => {
                this.setState(result);
                this.setDataReceived();
                globals.animatePageIn(this.container);
            });
    }

    setDataReceived() {
        this.setState({
            dataReceived: true
        });
    }

    render() {
        return (
            <div ref={(el) => this.container = el} style={{opacity: 0}}>
                <HelmetDefault {...this.state} />
                <Hero title={this.state.title} subTitle={this.state.subTitle} leadCopy={this.state.leadCopy} dataReceived={this.state.dataReceived} />
                <SecondHeading data={this.state.secondHeading} />
                <div className="row centered">
                    <div className="col-xs-12 mb-5">
                        <Button
                            action={(event) => window.slideFormContainer ? window.slideFormContainer.animateIn(event) : null}
                            image="/images/btn-get-in-touch.svg"
                            alt="Get in touch"
                        />
                    </div>
                </div>
            </div>
        );
    }

}

export default AwsPartners;



// WEBPACK FOOTER //
// ./resources/assets/js/pages/AwsPartner.js